let isShowNsgBox = false;

export default {
  UPDATE_USER_PROFILE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userProfile = payload;
  },

  UPDATE_MESSAGE_BOX(st, payload) {
    // eslint-disable-next-line no-param-reassign
    if(isShowNsgBox) return;
    isShowNsgBox = true;
    st.msgBox = payload;

    setTimeout(() => {
      st.msgBox.active = false;
      isShowNsgBox = false;
    }, 3000);
  },

  UPDATE_TEMPLATE_IMG(st, payload) {
    st.templateFiles = payload;
  },

  SAVE_FAST_HISTORY(st, payload) {
    if (st.fastHistory.some(x => x.auth_id === payload.auth_id)) { return; }
    st.fastHistory.push(payload);
  },

  RESET_FAST_HISTORY(st, payload) {
    st.fastHistory = [];
  },

  ADD_CHATGPT_DESCRIPTION(st, payload) {
    st.chatGptAsk.push(payload);
  },

  REMOVE_CHATGPT_DESCRIPTION(st, payload) {
    const findSameValue = st.chatGptAsk.filter(val => val !== payload);
    st.chatGptAsk = findSameValue
  },

  RESET_CHATGPT_DESCRIPTION(st, payload) {
    st.chatGptAsk = []
  },
  SET_NOTIFY_DATA({ notification }, payload) {
    Object.assign(notification, payload)
  },
  SET_EPRO_MODULES_QUES_LIST({ eproModuleQuesList }, payload) {
    Object.assign(eproModuleQuesList, payload)
  },
};
